import { Service } from '@angular/core';

export interface CookieOptions {
  domain?: string;
  path?: string;
  secure?: boolean;
  sameSite?: 'Strict' | 'Lax' | 'None';
  maxAge?: number; // in seconds
}

@Service()
export class CookieUtility {
  private static readonly LANGUAGE_COOKIE_NAME = 'lexplus_language';
  private static readonly DEFAULT_COOKIE_OPTIONS: CookieOptions = {
    path: '/',
    sameSite: 'Lax',
    maxAge: 365 * 24 * 60 * 60, // 1 year
  };

  public readCookie(name: string): string | null {
    const cookieString = document.cookie.split(';').find((cookie) => cookie.trim().startsWith(`${name}=`));

    if (!cookieString) {
      return null;
    }

    return decodeURIComponent(cookieString.split('=')[1]);
  }

  public readLanguageCookie(): string | null {
    return this.readCookie(CookieUtility.LANGUAGE_COOKIE_NAME);
  }

  public writeCookie(name: string, value: string, options?: CookieOptions): void {
    const mergedOptions = {
      ...CookieUtility.DEFAULT_COOKIE_OPTIONS,
      ...options,
    };

    let cookieString = `${name}=${encodeURIComponent(value)}`;

    if (mergedOptions.path) {
      cookieString += `; path=${mergedOptions.path}`;
    }

    if (mergedOptions.domain) {
      cookieString += `; domain=${mergedOptions.domain}`;
    }

    if (mergedOptions.secure) {
      cookieString += '; secure';
    }

    if (mergedOptions.sameSite) {
      cookieString += `; samesite=${mergedOptions.sameSite}`;
    }

    if (mergedOptions.maxAge) {
      cookieString += `; max-age=${mergedOptions.maxAge}`;
    }

    document.cookie = cookieString;
  }

  public writeLanguageCookie(language: string, options?: CookieOptions): void {
    this.writeCookie(CookieUtility.LANGUAGE_COOKIE_NAME, language, options);
  }

  public deleteCookie(name: string): void {
    this.writeCookie(name, '', { maxAge: -1 });
  }

  public deleteLanguageCookie(): void {
    this.deleteCookie(CookieUtility.LANGUAGE_COOKIE_NAME);
  }
}
